// extracted by mini-css-extract-plugin
export default {"ColonneLaboratoire":"PageLaboratoires_ColonneLaboratoire__7rOOU","ColonneCode":"PageLaboratoires_ColonneCode__3uY5J"};